import { render, staticRenderFns } from "./before-buy.vue?vue&type=template&id=e10d143a&scoped=true&"
import script from "./before-buy.vue?vue&type=script&lang=ts&"
export * from "./before-buy.vue?vue&type=script&lang=ts&"
import style0 from "./before-buy.vue?vue&type=style&index=0&id=e10d143a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10d143a",
  null
  
)

export default component.exports